import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { updateAppState } from '../../actions/applicationState';
import { ensureConversationForMatch } from '../../actions/messaging';
import { acceptMatch, declineMatch, endMatch, notNowMatch } from '../../actions/pooch';
import { getMember } from '../../actions/profile';
import { getCurrentMember, updateUser } from '../../actions/user';
import { Theme } from '../../config/theme';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import ActivityBadge from '../../components/ActivityBadge';
import ContentContainer from '../../components/ContentContainer';
import HorizontalRule from '../../components/HorizontalRule';
import MatchResponseModal from '../../components/MatchResponseModal';
import NotificationBar from '../../components/NotificationBar';
import ReportModal from '../../components/ReportModal';
import Reviews from '../../components/Reviews';
import ViewProfileCard from '../../components/ViewProfileCard';

const CHECK_ICON = require('./check.svg');
const LOCATION_ICON = require('./location.svg');
const PAW_ICON = require('./paw.svg');
const ENVELOPE_ICON = require('./envelope.svg');
const CROSS_ICON = require('./cross.svg');
const PREVIEW_ICON = require('./preview.svg');
const WARNING_ICON = require('./warning.svg');

class MemberProfile extends Component {
  constructor(props) {
    super(props);
    this.fetchProfile = this.fetchProfile.bind(this);
    this.reportModalHandler = this.openReportModalHandler.bind(this);
    this.writeReviewModalHandler = this.writeReviewModalOpenHandler.bind(this);
    this.pushReviewHandler = this.pushReview.bind(this);
    this.acceptRequest = this.acceptRequest.bind(this);
    this.endRequest = this.endRequest.bind(this);
    this.declineRequest = this.declineRequest.bind(this);
    this.notNowRequest = this.notNowRequest.bind(this);
    this.toggleResponseModal = this.toggleResponseModal.bind(this);
    this.handleResponseSubmit = this.handleResponseSubmit.bind(this);
    this.handleMessageMember = this.handleMessageMember.bind(this);
    this.state = {
      profile: null,
      profile_reviewable: false,
      open_report_modal: false,
      open_write_review_modal: false,
      response_modal_open: false,
      response_modal_type: 'decline',
      selected_match: null,
      message_loading: false,
    };
  }

  componentDidMount() {
    this.fetchProfile();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.fetchProfile();
    }
  }

  getPoliceChecked() {
    const profile = this.state.profile;

    if (profile && profile.police_checked) {
      return 'Police checked';
    }

    return false;
  }

  getLivingSituationMessage() {
    const profile = this.state.profile;

    if (profile && profile.living_situation && profile.availability.length) {
      return `Living Situation: ${profile.living_situation}`;
    }

    return false;
  }

  getAvailabilityMessage() {
    const profile = this.state.profile;

    if (profile && profile.availability && profile.availability.length) {
      return `Availability: ${profile.availability}`;
    }

    return false;
  }

  getRegularityMessage() {
    const profile = this.state.profile;

    if (profile && profile.regularity && profile.regularity.length) {
      return `Regularity: ${profile.regularity}`;
    }

    return false;
  }

  // Select the most appropriate name for the profile
  getProfileName() {
    return this.state.profile.display_name
      ? this.state.profile.display_name
      : this.state.profile.first_name;
  }

  getUserImage() {
    const user = this.state.profile;

    if (user.image_url && user.image_url.length > 10) {
      return user.image_url;
    }

    if (user.profile_photo && user.profile_photo.length > 10) {
      return user.profile_photo;
    }

    return '/images/default_profile.jpg';
  }

  // View the match requests from this user
  getMatchRequests() {
    const matches = this.props.user.matches;

    return matches && matches.length
      ? matches.filter(
          match =>
            match.borrower.id !== this.props.user.id &&
            match.borrower.id === this.state.profile.id &&
            match.status === 'Pending',
        )
      : false;
  }

  // View the active shares between
  // the borrower and owner, validates both
  // scenarios
  getCurrentShares() {
    const profile = this.state.profile;
    const currentUser = this.props.user;
    const matches = this.props.user.matches;

    const currentSharesWithBorrower =
      matches && matches.length
        ? this.props.user.matches.filter(
            match =>
              match.borrower.id !== currentUser.id &&
              match.borrower.id === profile.id &&
              match.status === 'Accepted',
          )
        : false;

    const currentSharesWithOwner =
      matches && matches.length
        ? this.props.user.matches.filter(
            match =>
              parseFloat(match.owner_id) !== currentUser.id &&
              parseFloat(match.owner_id) === profile.id &&
              match.status === 'Accepted',
          )
        : false;

    if (currentSharesWithBorrower && currentSharesWithBorrower.length) {
      return currentSharesWithBorrower;
    } else if (currentSharesWithOwner && currentSharesWithOwner.length) {
      return currentSharesWithOwner;
    }

    return false;
  }

  // Returns true if this is the profile of the current authenticated member
  getIsUser() {
    const profile = this.state.profile;
    const currentUser = this.props.user;

    return profile && profile.id && profile.id === currentUser.id;
  }

  setProfile(profile) {
    this.setState({
      profile,
    });
  }

  pushReview(newReview) {
    // gets current reviews state, iterates through existing
    // and does not add duplicate state values
    const currentReviews = this.state.profile.reviews;
    if (!currentReviews.length) {
      this.setState({
        profile: {
          ...this.state.profile,
          reviews: [...this.state.profile.reviews, newReview],
        },
      });
    } else {
      currentReviews.forEach(currentReview => {
        if (currentReview.reviewer_id !== newReview.reviewer_id) {
          this.setState({
            profile: {
              ...this.state.profile,
              reviews: [...this.state.profile.reviews, newReview],
            },
          });
        }
      });
    }
  }

  writeReviewModalOpenHandler() {
    this.setState({
      open_write_review_modal: !this.state.open_write_review_modal,
    });
  }

  openReportModalHandler() {
    this.setState({
      open_report_modal: !this.state.open_report_modal,
    });
  }

  profileIsReviewableHandler() {
    // Loop through profile reviews and check if this user
    // has already reviewed this profile
    const reviews = this.state.profile.reviews;
    const canReview = {};
    reviews.forEach(review => {
      if (this.props.user.id === review.reviewer_id) {
        if (
          !this.getIsUser() &&
          this.getCurrentShares() &&
          this.props.user.id !== review.reviewer_id
        ) {
          canReview.profile_reviewable = true;
        } else {
          canReview.profile_reviewable = false;
        }
      }
    });

    if (!this.getIsUser() && this.getCurrentShares() && reviews.length === 0) {
      canReview.profile_reviewable = true;
    } else {
      canReview.profile_reviewable = false;
    }

    this.setState(canReview);
  }

  fetchProfile() {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props
          .dispatch(getMember(this.props.match.params.id, this.props.user.access_token))
          .then(
            response => {
              this.setProfile(response);
              this.profileIsReviewableHandler();

              this.props.dispatch(
                updateAppState({
                  loading: false,
                }),
              );
            },
            err => {
              console.log(err); // eslint-disable-line no-console
              this.props.dispatch(
                updateAppState({
                  loading: false,
                }),
              );
              this.props.history.push('/404');
            },
          );
      });
  }

  handleMessageMember(match) {
    if (!match || !this.props.user || !this.props.user.access_token) {
      return;
    }

    this.setState({
      message_loading: match.id,
    });

    this.props
      .dispatch(ensureConversationForMatch(match.id, this.props.user.access_token))
      .then(conversation => {
        this.setState({
          message_loading: false,
        });
        this.props.history.push(`/inbox/${conversation.id}`);
      })
      .catch(error => {
        const errorMessage =
          (error && error.data && error.data.error) ||
          error.message ||
          'Unable to open conversation';
        toast.error(errorMessage);
        this.setState({
          message_loading: false,
        });
      });
  }

  acceptRequest(matchRequest) {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props.dispatch(acceptMatch(matchRequest.id, this.props.user.access_token)).then(
          () => {
            this.props
              .dispatch(getCurrentMember(this.props.user.id, this.props.user.access_token))
              .then(response => {
                this.props.dispatch(updateUser(response));

                this.props.dispatch(
                  updateAppState({
                    loading: false,
                  }),
                );
              });
          },
          err => {
            console.log(err); // eslint-disable-line no-console
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
          },
        );
      });
  }

  endRequest(matchRequest) {
    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        this.props.dispatch(endMatch(matchRequest.id, this.props.user.access_token)).then(
          () => {
            this.props
              .dispatch(getCurrentMember(this.props.user.id, this.props.user.access_token))
              .then(response => {
                this.props.dispatch(updateUser(response));

                this.props.dispatch(
                  updateAppState({
                    loading: false,
                  }),
                );
              });
          },
          err => {
            console.log(err); // eslint-disable-line
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
          },
        );
      });
  }

  declineRequest(matchRequest) {
    this.setState({
      selected_match: matchRequest,
      response_modal_type: 'decline',
      response_modal_open: true,
    });
  }

  notNowRequest(matchRequest) {
    this.setState({
      selected_match: matchRequest,
      response_modal_type: 'notNow',
      response_modal_open: true,
    });
  }

  toggleResponseModal() {
    this.setState({
      response_modal_open: !this.state.response_modal_open,
    });
  }

  handleResponseSubmit(message) {
    const matchRequest = this.state.selected_match;
    const actionType = this.state.response_modal_type;

    this.props
      .dispatch(
        updateAppState({
          loading: true,
        }),
      )
      .then(() => {
        const action =
          actionType === 'decline'
            ? declineMatch(matchRequest.id, message, this.props.user.access_token)
            : notNowMatch(matchRequest.id, message, this.props.user.access_token);

        this.props.dispatch(action).then(
          () => {
            this.props
              .dispatch(getCurrentMember(this.props.user.id, this.props.user.access_token))
              .then(response => {
                this.props.dispatch(updateUser(response));

                this.props.dispatch(
                  updateAppState({
                    loading: false,
                  }),
                );
              });
          },
          err => {
            console.log(err); // eslint-disable-line no-console
            this.props.dispatch(
              updateAppState({
                loading: false,
              }),
            );
          },
        );
      });
  }

  renderCurrentlySharing() {
    const isUser = this.getIsUser();
    const currentShares = this.getCurrentShares();

    return !isUser && currentShares ? (
      <button className={css(styles.action, styles.sharing, styles.no_action)}>
        <Isvg
          cacheGetRequests
          src={PAW_ICON}
          className={css(styles.paw_icon, styles.paw_icon_blue)}
        />
        {"You're"} dog sharing
      </button>
    ) : (
      false
    );
  }

  renderMessageAction() {
    const isUser = this.getIsUser();
    const currentShares = this.getCurrentShares();

    if (isUser || !currentShares || !currentShares.length) {
      return false;
    }

    const primaryMatch = currentShares[0];
    const isLoading = this.state.message_loading === primaryMatch.id;

    return (
      <button
        onClick={() => this.handleMessageMember(primaryMatch)}
        className={css(styles.action, styles.message_owner)}
        disabled={isLoading}
      >
        <Isvg cacheGetRequests src={ENVELOPE_ICON} className={css(styles.envelope_icon)} />
        {isLoading ? 'Opening messages...' : 'Message'}
      </button>
    );
  }

  renderPendingMatchRequests() {
    const matchRequests = this.getMatchRequests();

    return matchRequests ? (
      <div className={css(styles.pending_match_requests)}>
        <strong className={css(styles.pending_title)}>Pending match requests</strong>
      </div>
    ) : (
      false
    );
  }

  renderDiscontinueSharing() {
    const isUser = this.getIsUser();
    const currentShares = this.getCurrentShares();

    return !isUser && currentShares ? (
      <button
        onClick={this.endRequest.bind(this, currentShares[0])}
        className={css(styles.action, styles.discontinue_sharing)}
      >
        <Isvg cacheGetRequests src={CROSS_ICON} className={css(styles.cross_icon)} />
        Discontinue Sharing
      </button>
    ) : (
      false
    );
  }

  renderReportMember() {
    const isUser = this.getIsUser();
    const currentShares = this.getCurrentShares();

    return !isUser && currentShares ? (
      <a // eslint-disable-line
        className={css(styles.report_member)}
        onClick={this.openReportModalHandler}
      >
        <Isvg cacheGetRequests src={WARNING_ICON} className={css(styles.warning_icon)} />
        Report member
      </a>
    ) : (
      false
    );
  }

  renderAcceptShare() {
    const matchRequests = this.getMatchRequests();

    return matchRequests
      ? matchRequests.map(match => (
          <div key={match.id}>
            <button
              onClick={this.acceptRequest.bind(this, match)}
              className={css(styles.action, styles.share_request)}
            >
              <Isvg cacheGetRequests src={PAW_ICON} className={css(styles.paw_icon)} />
              Accept
            </button>
            <button
              onClick={this.declineRequest.bind(this, match)}
              className={css(styles.action, styles.decline_request)}
            >
              <Isvg cacheGetRequests src={CROSS_ICON} className={css(styles.cross_icon)} />
              Decline
            </button>
            <button
              onClick={this.notNowRequest.bind(this, match)}
              className={css(styles.action, styles.not_now_request)}
            >
              Not Now
            </button>
          </div>
        ))
      : false;
  }

  render() {
    return (
      <div className={css(styles.body)}>
        {this.getIsUser() ? (
          <NotificationBar>
            <Isvg cacheGetRequests src={PREVIEW_ICON} className={css(styles.preview_icon)} />
            This is how others will view your profile.
            <Link
              to={`/profile/${this.state.profile.id}/edit`}
              className={css(styles.notification_link)}
            >
              Edit profile
            </Link>
          </NotificationBar>
        ) : (
          false
        )}
        <div className={css(styles.primary_container)}>
          <ContentContainer styles={styles.container}>
            <div className={css(styles.profile)}>
              <div className={css(styles.gallery)}>
                <div className={css(styles.gallery_main)}>
                  {this.state.profile ? (
                    <img
                      className={css(styles.gallery_photo)}
                      src={this.getUserImage()}
                      alt={this.state.profile ? this.getProfileName() : null}
                    />
                  ) : (
                    false
                  )}
                </div>
              </div>
              <div className={css(styles.details)}>
                <h1 className={css(styles.name)}>
                  {this.state.profile ? this.getProfileName() : false}
                </h1>
                <div className={css(styles.location)}>
                  <Isvg
                    cacheGetRequests
                    src={LOCATION_ICON}
                    className={css(styles.location_icon)}
                  />
                  {this.state.profile && this.state.profile.suburb
                    ? `${this.state.profile.suburb.title}, ${this.state.profile.suburb.district.title}`
                    : 'Location not shared'}
                </div>
                {this.state.profile && this.state.profile.availability ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    {this.state.profile.availability}
                  </div>
                ) : (
                  false
                )}
                {this.getPoliceChecked() ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    {this.getPoliceChecked()}
                  </div>
                ) : (
                  false
                )}
                {this.getLivingSituationMessage() ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    {this.getLivingSituationMessage()}
                  </div>
                ) : (
                  false
                )}
                {this.getAvailabilityMessage() ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    {this.getAvailabilityMessage()}
                  </div>
                ) : (
                  false
                )}
                {this.getRegularityMessage() ? (
                  <div className={css(styles.socialised)}>
                    <Isvg cacheGetRequests src={CHECK_ICON} className={css(styles.check_icon)} />
                    {this.getRegularityMessage()}
                  </div>
                ) : (
                  false
                )}
              </div>
            </div>
            {this.state.profile ? (
              <div className={css(styles.actions)}>
                {this.renderCurrentlySharing()}
                {this.renderMessageAction()}
                {this.renderDiscontinueSharing()}
                {this.renderAcceptShare()}
                {this.renderReportMember()}
              </div>
            ) : (
              false
            )}
          </ContentContainer>
        </div>
        <div className={css(styles.secondary_container)}>
          <ContentContainer styles={styles.container}>
            <div className={css(styles.sections)}>
              {this.state.profile && this.state.profile.bio ? (
                <div className={css(styles.section)}>
                  <h2 className={css(styles.section_title)}>About Me</h2>
                  <div className={css(styles.section_content)}>
                    <p className={css(styles.section_paragraph)}>{this.state.profile.bio}</p>
                  </div>
                </div>
              ) : (
                false
              )}

              {this.state.profile && this.state.profile.interests.length ? (
                <HorizontalRule />
              ) : (
                false
              )}
              {this.state.profile && this.state.profile.interests.length ? (
                <div className={css(styles.section)}>
                  <h2 className={css(styles.section_title)}>{"I'm Interested in"}</h2>
                  <div className={css(styles.section_content)}>
                    <div className={css(styles.activities)}>
                      {this.state.profile.interests.map(interest => (
                        <ActivityBadge activity={interest.title} label styles={styles.activity} />
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                false
              )}

              {this.state.profile && this.state.profile.needs && this.state.profile.needs.length ? (
                <HorizontalRule />
              ) : (
                false
              )}
              {this.state.profile && this.state.profile.needs && this.state.profile.needs.length ? (
                <div className={css(styles.section)}>
                  <h2 className={css(styles.section_title)}>{"I'm good with"}</h2>
                  <div className={css(styles.section_content)}>
                    <ul className={css(styles.bullet_list)}>
                      {this.state.profile.needs.map(need => (
                        <li className={css(styles.bullet_item)}>{need.title}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ) : (
                false
              )}
              <HorizontalRule />
              {this.state.profile ? (
                <span>
                  <Reviews
                    open={this.state.open_write_review_modal}
                    openHandler={this.writeReviewModalHandler}
                    reviews={this.state.profile.reviews}
                    canReview={this.state.profile_reviewable}
                    pushReviewHandler={this.pushReviewHandler}
                    {...this.props}
                  />
                  <HorizontalRule />
                </span>
              ) : (
                false
              )}
            </div>
            {this.state.profile && this.state.profile.dogs && this.state.profile.dogs.length ? (
              <div className={css(styles.side)}>
                <h2 className={css(styles.section_title)}>{`${this.getProfileName()}'s dogs`}</h2>
                {this.state.profile.dogs.map(dog => (
                  <ViewProfileCard dog {...dog} />
                ))}
              </div>
            ) : (
              false
            )}
            {this.state.profile && this.renderReportMember() ? (
              <ReportModal
                open={this.state.open_report_modal}
                openHandler={this.openReportModalHandler}
                {...this.props}
              />
            ) : (
              false
            )}
            {this.state.selected_match ? (
              <MatchResponseModal
                isOpen={this.state.response_modal_open}
                onClose={this.toggleResponseModal}
                onSubmit={this.handleResponseSubmit}
                actionType={this.state.response_modal_type}
                borrowerName={
                  this.state.selected_match.borrower.display_name ||
                  this.state.selected_match.borrower.first_name
                }
                dogName={this.state.selected_match.dog.name}
              />
            ) : (
              false
            )}
          </ContentContainer>
        </div>
      </div>
    );
  }
}

MemberProfile.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const styles = StyleSheet.create({
  body: {
    position: 'relative',
    marginTop: 30,

    [Theme.mobile_query]: {
      marginTop: 0,
    },
  },
  preview_icon: {
    marginRight: 10,
  },
  notification_link: {
    marginLeft: 5,
    fontWeight: 'bold',
  },
  cross_icon: {
    position: 'relative',
    top: 1,
    marginRight: 10,
  },
  warning_icon: {
    position: 'relative',
    top: 4,
    marginRight: 10,
  },
  envelope_icon: {
    position: 'relative',
    top: 3,
    marginRight: 10,
  },
  paw_icon: {
    position: 'relative',
    top: 2,
    marginRight: 10,
    fill: Theme.white,
  },
  paw_icon_blue: {
    fill: '#39b4d6',
  },
  activities: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  activity: {
    marginBottom: 60,

    ':not(:last-child)': {
      marginRight: 35,
    },
  },
  bullet_list: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    marginBottom: -14,
  },
  bullet_item: {
    display: 'flex',
    alignItems: 'center',
    width: '33.3333%',
    marginBottom: 14,
    fontSize: 15,
    lineHeight: 1.53,
    letterSpacing: 0.3,
    color: '#000e1f',
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,

    [Theme.mobile_query]: {
      width: '100%',
    },

    ':before': {
      height: 5,
      width: 5,
      marginRight: 10,
      backgroundColor: '#39b4d6',
      borderRadius: '50%',
      content: '""',
    },
  },
  sections: {
    width: 750,

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  side: {
    width: 360,
    flexShrink: 0,

    [Theme.mobile_query]: {
      width: '100%',
      paddingTop: 50,
    },
  },
  section: {
    display: 'flex',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  section_content: {
    flexGrow: 1,
  },
  section_title: {
    flexShrink: 0,
    width: 195,
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_family_secondary,
    letterSpacing: 1.8,
    color: '#a5a5a5',
    fontSize: 13,
    lineHeight: 1.53,
    textTransform: 'uppercase',

    [Theme.mobile_query]: {
      marginBottom: 15,
    },
  },
  section_paragraph: {
    fontSize: 15,
    lineHeight: 1.53,
    letterSpacing: 0.3,
    color: '#000e1f',
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,

    ':not(:last-child)': {
      marginBottom: 15,
    },
  },
  primary_container: {
    display: 'flex',
    padding: '84px 0 25px',
    backgroundColor: '#F8F8F8',
  },
  secondary_container: {
    padding: '54px 0 150px',

    [Theme.mobile_query]: {
      paddingBottom: 0,
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',

    [Theme.mobile_query]: {
      flexDirection: 'column',
      paddingBottom: 50,
    },
  },
  profile: {
    display: 'flex',

    [Theme.mobile_query]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
  },
  details: {
    paddingLeft: 38,
    paddingTop: 40,

    [Theme.mobile_query]: {
      paddingLeft: 0,
    },
  },
  name: {
    marginBottom: 18,
    fontSize: 45,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    color: '#000e1f',

    [Theme.mobile_query]: {
      fontSize: 28,
    },
  },
  breed: {
    marginBottom: 17,
    fontSize: 20,
    fontFamily: Theme.font_family_primary,
    fontWeight: 500,
    color: '#000e1f',

    [Theme.mobile_query]: {
      fontSize: 18,
    },
  },
  location: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 17,
    fontSize: 15,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    color: '#000e1f',
  },
  location_icon: {
    display: 'block',
    marginRight: 9,
  },
  socialised: {
    display: 'flex',
    alignItems: 'left',
    fontSize: 14,
    fontFamily: Theme.font_family_primary,
    fontWeight: 900,
    paddingTop: 10,
    paddingBottom: 10,
    color: '#000e1f',
  },
  check_icon: {
    display: 'block',
    marginRight: 10.8,
  },
  gallery: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  gallery_main: {
    height: 360,
    width: 360,
    backgroundColor: Theme.grey,

    [Theme.mobile_query]: {
      width: 290,
      height: 'auto',
    },
  },
  gallery_photo: {
    display: 'block',
    height: 360,
    width: 360,
    border: '4px solid #fff',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, .1)',
    objectFit: 'cover',

    [Theme.mobile_query]: {
      width: 290,
      height: 'auto',
    },
  },
  gallery_indicators: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
  },
  gallery_indicator: {
    height: 14,
    width: 14,
    margin: '0 10px',
    border: '1px solid #d0d0d0',
    backgroundColor: Theme.white,
    borderRadius: '50%',
    transition: 'all 300ms',
    cursor: 'pointer',
    outline: 'none',
  },
  no_action: {
    cursor: 'default',
  },
  gallery_indicator_active: {
    borderColor: '#39b4d6',
    backgroundColor: '#39b4d6',
  },
  actions: {
    width: 294,
    paddingTop: 100,

    [Theme.mobile_query]: {
      width: '100%',
      paddingTop: 30,
    },
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
    width: 293,
    height: 50,
    padding: '0 18px',
    textTransform: 'uppercase',
    fontSize: 15,
    fontFamily: Theme.font_family_secondary,
    fontWeight: 900,
    letterSpacing: 2,
    textAlign: 'center',
    borderRadius: 5,
    border: 0,
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    '@media screen and (max-width: 750px)': {
      width: 230,
    },

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  share_request: {
    color: Theme.white,
    backgroundColor: Theme.primary,

    ':hover': {
      backgroundColor: '#61c3df',
    },
  },
  message_owner: {
    color: Theme.white,
    backgroundColor: '#000e1f',
    ':disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  },
  discontinue_sharing: {
    color: Theme.white,
    backgroundColor: Theme.error,
  },
  sharing: {
    color: '#000e1f',
    backgroundColor: Theme.white,
  },
  pending_match_requests: {
    marginTop: 30,
    textAlign: 'center',
    marginBottom: 20,
  },
  pending_title: {
    textAlign: 'center',
    flexShrink: 0,
    width: 195,
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_family_secondary,
    letterSpacing: 1.8,
    color: '#a5a5a5',
    fontSize: 13,
    lineHeight: 1.53,
    textTransform: 'uppercase',
  },
  report_member: {
    float: 'right',
    padding: 10,
    cursor: 'pointer',
  },
  decline_request: {
    color: Theme.white,
    backgroundColor: Theme.error,
  },
  not_now_request: {
    color: Theme.white,
    backgroundColor: Theme.primary,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MemberProfile);



// WEBPACK FOOTER //
// ./src/views/MemberProfile/index.js